module.exports = __webpack_public_path__ + "2acb60f2/img/pdf-icon.79f04a36.svg";